import Permissions from '../../models/Permissions'
const FormUser = () => import(/* webpackChunkName: "formUser" */ './FormUser.vue')
const GridUsers = () => import(/* webpackChunkName: "gridUsers" */ './GridUsers.vue')
const FormProfile = () => import(/* webpackChunkName: "formProfile" */ './FormProfile.vue')

const permissions = [
  Permissions.ROOT,
  Permissions.ADMINISTRADOR
]

const create = {
  path: 'user/create',
  name: 'User',
  component: FormUser,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const edit = {
  path: 'user/edit/:cnpj/:cpf',
  name: 'Edit User',
  component: FormUser,
  props: true,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

const profile = {
  path: 'user/profile',
  name: 'User Profile',
  component: FormProfile,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

const list = {
  path: 'users',
  name: 'User List',
  component: GridUsers,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: permissions
  }
}

export default {
  create,
  edit,
  profile,
  list,
  permissions
}

export {
  permissions
}
